import { PerformanceProfilePersonalReview } from '../models/performance-profile-personal-review.model';

export class AddPerformanceProfilePersonalReviews {
    static readonly type = '[PerformanceProfilePersonalReview] AddPerformanceProfilePersonalReviews';

    constructor(public payload: PerformanceProfilePersonalReview[]) {}
}
